import React from 'react';
import { AdvancedImage, lazyload, responsive } from '@cloudinary/react';
import { TextVariant } from '@naf/text';
import { useDocumentUrlWithNode } from '../../../../hooks/Documents/useDocumentUrl';
import { useCloudinary } from '../../../../hooks/Cloudinary/useCloudinary';
import { InternalMainEntry } from '../../../../../../types/InternalMainEntryType';
import { Card, ImageWrapper, Label, StyledText, StyledLink, UnderlinedElement } from './Styles';

export interface InternalMainEntryCardProps {
  internalMainEntry: InternalMainEntry;
}

export const InternalMainEntryCard = ({ internalMainEntry: { image, data } }: InternalMainEntryCardProps) => {
  const url = useDocumentUrlWithNode(data) || '';

  const { getResponsiveImage } = useCloudinary();

  const mainImage =
    (image &&
      getResponsiveImage(image.publicId, {
        format: 'svg',
        devicePR: 3.0,
        focusMethod: image?.focus,
        width: 120,
      })) ||
    undefined;

  return (
    <StyledLink to={url}>
      <Card>
        {mainImage && (
          <ImageWrapper>
            <AdvancedImage
              cldImg={mainImage}
              alt={image.altText || image.caption}
              plugins={[responsive({ steps: 200 }), lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 })]}
            />
          </ImageWrapper>
        )}
        <Label>
          <StyledText variant={TextVariant.CardHeader}>
            <UnderlinedElement>{data.name}</UnderlinedElement>
          </StyledText>
        </Label>
      </Card>
    </StyledLink>
  );
};
